import { BLOG_PATH, HOME_PATH, PAGE_PATH, POLICY_PATH, REGISTRATION_STEP_1_PATH } from '~/constants';
import type { PageUrlType, SanityLinkFragment, UrlType } from '~/types/sanity/link';
import { pageUrlTypes } from '~/types/sanity/link';

/**
 * A type guard to check if a URL type is a page URL type
 * @param urlType - the URL type to check
 * @returns `true` if the URL type is a page URL type, `false` otherwise.
 */
export const isPageUrlType = (urlType: UrlType): urlType is PageUrlType => {
  return pageUrlTypes.some((type): type is PageUrlType => type === urlType);
};

/**
 * Formats and prefixes the URL with the appropriate path based on the Sanity
 * link object.
 *
 * @param link - the Sanity link object to build the URL from
 * @returns relative URL
 */
export const buildSanityLinkUrl = (link: SanityLinkFragment): string => {
  let formattedUrl = link.url;

  if (link.url.includes('homepage')) {
    formattedUrl = HOME_PATH;
  } else if (isPageUrlType(link.urlType)) {
    formattedUrl = `${PAGE_PATH}${link.url}`;
  } else if (link.urlType === 'blogArticle') {
    formattedUrl = `${BLOG_PATH}${link.url}`;
  } else if (link.urlType === 'policy') {
    formattedUrl = `${POLICY_PATH}${link.url}`;
  }

  // Apply overrides for specific URLs
  if (formattedUrl.includes('registration')) {
    formattedUrl = REGISTRATION_STEP_1_PATH;
  }

  return formattedUrl;
};
